import { ConsoleLogger } from '@proposify/frontend-observability';
import { createIndexedDBHandler } from 'utils/indexeddb';

const DATABASE_NAME = 'proposify';
const DATABASE_VERSION = 1;
const TABLE_NAME = 'preview-tracking';
const PRIMARY_KEY = 'id';

type PersistedTrackingData = {
  id: string;
  viewTimes: Map<string, number>;
  startedAt: number;
};

export const PreviewTrackingIndexedDB = createIndexedDBHandler<PersistedTrackingData, 'id'>({
  logger: ConsoleLogger,
  databaseName: DATABASE_NAME,
  databaseVersion: DATABASE_VERSION,
  tableName: TABLE_NAME,
  primaryKey: PRIMARY_KEY,
});
